module.exports = __webpack_public_path__ + "static/upfeed-illustration-eec23c3cafe0336cea23b18a7d26779d.png";